// import 'babel-polyfill'
import React from 'react'
import { render } from 'react-dom'
import browserHistory from 'commonComps/history'
import { syncHistoryWithStore } from 'react-router-redux'
// import nothing from './services/autoload'
import Root from './containers/Root'
import configureStore from './store/configureStore'
global.jQuery = require('jquery')
require('bootstrap')

const store = configureStore()
const history = syncHistoryWithStore(browserHistory, store)

const app = <Root store={store} history={history} />

render(app, document.getElementById('root'))
